import {
  isComponentType,
  isPage,
  type PageBase,
  useCurrentPage,
  currentUrl,
  currentLanguage,
  useCurrentCountry,
} from '@avensia/excite';
import { useEffect } from 'react';
import { addPurchaseEvent } from './purchase';
import { pageToDataLayerInfo, getRetailMediaSessionId, getTrackingTimestamp } from '../utils';
import { addCheckoutEvent } from './checkout';
import { addItemViewEvent } from './items';
import { addToDataLayer, type DataLayerEvent } from '..';

export type PageLoadEvent = DataLayerEvent & {
  event: 'page_view';
  url: string;
  title: string;
  pageType: string;
};

let last_page_referrer: string | undefined = undefined;

let page_counter = 0;
let last_canonical_page_url: string | undefined = undefined;
let last_window_path_search: string | undefined = undefined;
let isHardLoad = true;
export function usePageTracking() {
  const currentPage = useCurrentPage();
  const currentCountry = useCurrentCountry();

  useEffect(() => {
    if (isPage(currentPage)) {
      addPageActionToDataLayer(currentPage, currentCountry.twoLetterCode);
    }

    isHardLoad = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage.url]);
}

async function addPageActionToDataLayer(page: PageBase, currentCountryTwoLetterCode: string) {
  const canonical = page.metaInfo?.canonicalUrl || undefined;

  if (canonical && last_canonical_page_url === canonical) {
    return;
  }

  const event = {
    event: 'page_view',
    event_info: {
      ...pageToDataLayerInfo(page),
      page_path_number: ++page_counter,
      page_internal_referrer: last_window_path_search,
      page_referrer: isHardLoad ? document?.referrer : last_page_referrer,
      chat_availability: window?.fcWidget?.isLoaded() || false,
      market: currentCountryTwoLetterCode,
      language: currentLanguage(),
      timestamp: getTrackingTimestamp(),
      retail_media_session_id: getRetailMediaSessionId(),
    },
  };

  last_window_path_search = window?.location.pathname + window?.location.search || undefined;
  last_canonical_page_url = canonical;
  last_page_referrer = currentUrl().toString();

  addToDataLayer(event);
  if (isComponentType<NordicNest.Api.ProductPageApiModel>(page)) {
    await addItemViewEvent(page.trackingProductInformation);
  } else if (isComponentType<NordicNest.Api.OrderConfirmationPageApiModel>(page)) {
    await addPurchaseEvent(page);
  } else if (isComponentType<NordicNest.Api.CheckoutPageApiModel>(page)) {
    await addCheckoutEvent();
  }
}
